
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './cars.json'; // The JSON you provided

const Cars = () => {
  return (
    <div className="topic-page-container">
        {/* We can still use your Layout, but we pass the Router as children or a prop */}
        <TopicsPageLayout
            
            description="Automotive vocabulary, electric vehicles, and transport discussions. B2 level English exercises with grammar, reading, and vocabulary."
            level="B2"
            title="Cars"
            image="/Images/60bus-car-bike.webp"
            seoTitle="Free English Lesson Plans: Cars"
            seoDescription="Automotive vocabulary, electric vehicles, and transport discussions. B2 level English exercises with grammar, reading, and vocabulary."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default Cars;


